<template>
  <main class="dashboard prdts">
    <div class="container-fluid container-fluid--max">
      <notification></notification>
      <div class="card">
        <div class="dash-prdts card-body d-flex px-lg-5" :class="'dashboard__content' + (productRegistrations.length ? '' : '--empty')">
          <h1 class="dashboard__title heading-secondary mb-0">Mes produits</h1>
          <moon-loader :loading="loadingRequest" color="#dc3545" size="30px" class="ml-4"></moon-loader>
          <section class="dash-prdts__list my-4" v-if="productRegistrations.length">
            <c-card v-for="pr in productRegistrations" :key="pr.id" :item="pr" :id="'product_registration' + pr.id">
              <template v-slot:header>
                <div class="dash-prdts__img-wrapper prdt-card__img-wrapper col-auto">
                  <img :alt="pr.product.name" :src="pr.product.image_path || require('@/assets/images/product-placeholder.png')" class="dash-prdts__img prdt-card__img img-fluid">
                </div>
                <div class="prdt-card__details col-auto">
                  <h3 class="prdt-card__name">
                    {{ pr.product.name }}
                    <small v-if="pr.product.stove_type" class="bg-dark text-white px-2">{{ pr.product.stove_type }}</small>
                  </h3>
                  <div class="smaller thin">
                    <p class="mb-2">N° de série : <span class="prdt-card__value" v-if="pr.serial_number">{{ pr.serial_number }}</span></p>
                    <p class="mb-2">Date d’achat : <span class="prdt-card__value" v-if="pr.purchased_at">{{ pr.formatted_purchased_at }}</span></p>
                  </div>
                </div>
              </template>
              <template v-slot:button v-if="pr.no_review && pr.kind === 'bestove'">
                <router-link
                  :to="{ name: 'productRegistrationReview', params: { id: pr.id } }"
                  class="dashboard__details-btn btn thin mb-2 mb-md-0 mr-md-3"
                  :class="'btn-outline-' + $mainColor"
                  @click.native="$scrollToTop">
                  Laisser un avis
                </router-link>
              </template>
              <template v-slot:button v-else>
                <span class="rating-display rating-display--5stars mr-4" v-if="pr.kind === 'bestove'">
                  <span class="rating-display__rating rating-display--5stars__rating" :style="'width:' + pr.rating * 20 +'%;'"></span>
                </span>
              </template>
              <div slot="body" class="row">
                <div class="dash-prdts__details-col col-12 col-md">
                  <div class="dash-prdts__details-block">
                    <h3 class="heading-secondary">Achat</h3>
                    <s-field label="Lieu d'achat" :value="pr.formatted_purchased_place"></s-field>
                    <s-field label="Garantie" :value="pr.formatted_guarantee"></s-field>
                  </div>
                  <div class="dash-prdts__details-block mt-4">
                    <h3 class="heading-secondary">Documents</h3>
                    <div v-for="file in pr.documents" :key="file.title">
                      <p class="mb-1 smaller">
                        {{ file.title }} :
                        <a class="has-icon btn-link btn p-0 smaller" :class="'text-' + $mainColor" v-if="file.url" :href="file.url" target="_blank">voir <i class="fa fa-eye"></i></a>
                        <a href="#" class="disabled" v-else>non défini</a>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="dash-prdts__details-col col-12 col-md">
                  <div class="dash-prdts__details-block mt-4 mt-md-0">
                    <h3 class="heading-secondary">Installation</h3>
                    <s-field label="Prise d'air" :value="pr.air_intake"></s-field>
                    <s-field label="Tubage" :value="pr.formatted_venting_type"></s-field>
                    <s-field label="Type du conduit" :value="pr.formatted_pipe_type"></s-field>
                    <s-field label="Longueur du conduit" :value="pr.pipe_length"></s-field>
                    <s-field label="Détails de l'installation" :value="pr.install_details"></s-field>
                  </div>
                  <div class="dash-prdts__details-block mt-4">
                    <h3 class="heading-secondary">Installateur</h3>
                    <s-field label="Société" :value="pr.formatted_fitter_name" v-if="pr.fitter_type == 'pro'"></s-field>
                    <s-field label="Moi-même" :noValue="true" v-if="pr.fitter_type == 'self'"></s-field>
                  </div>
                </div>
                <div class="dash-prdts__details-col col-12 col-md">
                  <div class="dash-prdts__details-block mt-4 mt-md-0">
                    <h3 class="heading-secondary">Dernière Assistance</h3>
                    <p class="mb-1 smaller" v-if="lastSrStatus(pr)">
                      Statut : <span :class="'text-' + lastSrStatus(pr).badge">{{ lastSrStatus(pr).title }}</span>
                    </p>
                    <p class="smaller text-muted mt-3 text-center" v-else>
                      Aucune demande d'assistance en cours
                    </p>
                    <div class="mt-md-4">
                      <div v-for="sr in pr.support_requests" :key="'sr-' + sr.id">
                        <router-link
                          :to="{ name: 'supportRequests', query: { id: sr.id }, hash: `#support_request${sr.id}` }"
                          class="btn btn-block my-3"
                          :class="'btn-outline-' + $mainColor">
                          Demande #{{ sr.id }}
                        </router-link>
                      </div>
                      <router-link
                        :to="{ name: 'supportRequestForm', query: { id: pr.id } }"
                        class="btn btn-block my-3"
                        :class="'btn-outline-' + $mainColor"
                        @click.native="$scrollToTop">
                        Nouvelle demande
                      </router-link>
                      <router-link
                        :to="{ name: 'productRegistrationForm', params: { id: pr.id} }"
                        class="btn btn-block my-3"
                        :class="'btn-' + $mainColor"
                        @click.native="$scrollToTop">
                        Éditer mon produit
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </c-card>
          </section>
          <router-link
            :to="{ name: 'productRegistrationForm', params: { id: 'new'} }"
            class="dashboard__btn btn align-self-end ml-auto"
            :class="'btn-' + $mainColor"
            @click.native="$scrollToTop">
            Ajouter un nouveau produit
          </router-link>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import MoonLoader from 'vue-spinner/src/MoonLoader.vue'
import SpecifiedField from '@/components/ui/SpecifiedField'
import { mapState, mapGetters } from 'vuex'
import store from '@/store'
import { scrollAnchor } from '@/utils/helpers'

export default {
  name: 'ProductRegistrations',
  components: {
    's-field': SpecifiedField,
    MoonLoader
  },
  computed: {
    ...mapState(['loadingRequest']),
    ...mapGetters({ productRegistrations: `${store.$appName}/productRegistrations` })
  },
  mounted () {
    scrollAnchor(this.$router)
    if (this.$route.params.notification) {
      this.$store.dispatch('setNotification', {
        message: this.$route.params.notification,
        mode: 'success'
      })
    }
  },
  methods: {
    lastSrStatus (pr) {
      if (pr.support_requests.length) return _.last(pr.support_requests).status
      else return false
    }
  }
}
</script>
